<template>
  <div class="forgot col-xl-4 mx-auto">
    <h3 class="mb-4">Reset your password</h3>
    <b-form-group label="Email" :state="IsFieldValid($v.email)" :invalid-feedback="RequiredMessage('Email', $v.email)">
      <b-form-input v-model="$v.email.$model" :state="IsFieldValid($v.email)" />
    </b-form-group>
    <b-button @click="resetPassword" variant="success" :disabled="isLoading">
      <span v-if="isLoading"><b-spinner small></b-spinner> Please Wait...</span>
      <span v-else>Reset Password</span>
    </b-button>
    <b-alert show :variant="success ? 'info' : 'danger'" v-if="success != ''" class="text-left mt-3">
      <p class="mb-0">{{ success ? 'An email has been sent to the specified address.' : 'Something went wrong.' }}</p>
    </b-alert>
  </div>
</template>

<script>
import UserService from '../services/UserService.js'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      success: '',
      isLoading: false
    }
  },
  validations() {
    return {
      email: { required, email }
    }
  },
  methods: {
    resetPassword() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.isLoading = true
      UserService.forgotPassword(this.email).then(() => {
        this.success = true
        this.isLoading = false
      }).catch(() => {
        this.success = false
        this.isLoading = false
      })
    }
  }
}
</script>